import React, { useEffect, useState } from 'react';
import Table from '../../../../components/Table/Table';
import { UilArrowUp, UilArrowDown } from '@iconscout/react-unicons';
import myClasses from '../../SmartCharging.module.css';
import buttonClasses from '../../../../components/Buttons/Button.module.css';

const EventsTrasks = ({ sessions = [] }) => {
    const [logs, setLogs] = useState([]);

    useEffect(() => {
        if (Array.isArray(sessions)) {
            const processed = sessions.map((s) => {
                return {
                    ...s,
                    change: (
                        <div className={myClasses.ActionIcons}>
                            {s.difference > 0 ? (
                                <>
                                    <UilArrowUp className={buttonClasses.ButtonIcon} style={{ color: 'lightgreen' }} />
                                    {s.difference}
                                </>
                            ) : s.difference < 0 ? (
                                <>
                                    <UilArrowDown className={buttonClasses.ButtonIcon} style={{ color: 'red' }} /> {s.difference}
                                </>
                            ) : (
                                s.difference
                            )}
                        </div>
                    ),
                };
            });
            setLogs(processed);
        }
    }, [JSON.stringify(sessions)]);

    return (
        <div style={{ width: '60vw', maxHeight: '80vh', overflowY: 'scroll' }}>
            <div>
                <Table
                    head={['Charger ID', 'Connector ID', 'Session ID', 'Connector Capacity (kW)', 'Allocated (kW)', 'Change (kW)']}
                    keys={['evseId', 'connectorId', 'sessionId', 'connectorMaxCapacity', 'allocatedPower', 'change']}
                    data={logs}
                />
            </div>
        </div>
    );
};

export default EventsTrasks;
